import { connect } from 'react-redux';
import { selectors } from 'app-webtech-core';
import { _PrivacyPolicyUpdateNotificationComponent as PrivacyPolicyClass } from 'app-modules/application/components/PrivacyPolicyUpdate/Notification';
import { RemoteControllerComponent } from '../components/RemoteController';
import {
  dpadDown,
  dpadLeft,
  dpadRight,
  dpadUp,
  ok,
  esc,
  tab,
  home,
  end,
  characters,
  space,
} from '../actions';

const mapStateToProps = (state) => ({
  isTOSNotificationVisible: !PrivacyPolicyClass.shouldHideNotification(
    state.application.isConfigured && state.application.setup
      ? state.application.setup.userCountryCode
      : 'na',
  ),
  playerIsFullscreen: selectors.player.properties(state).isFullscreen,
  isCCMenuOpen: selectors.player.properties(state).isCCMenuOpen,
  currentCCMenu: selectors.player.properties(state).currentCCMenu,
  currentSelectionID: selectors.player.properties(state).currentSelectionID,
});

const mapDispatchToProps = (dispatch) => ({
  onUpButtonPressed: () => dispatch(dpadUp()),
  onDownButtonPressed: () => dispatch(dpadDown()),
  onDPadLeftButtonPressed: () => dispatch(dpadLeft()),
  onDPadRightButtonPressed: () => dispatch(dpadRight()),
  onOkButtonPressed: () => dispatch(ok()),
  onEscButtonPressed: () => dispatch(esc()),
  onTabButtonPressed: () => dispatch(tab()),
  onHomeButtonPressed: () => dispatch(home()),
  onEndButtonPressed: () => dispatch(end()),
  onSpaceButtonPressed: () => dispatch(space()),
  onCharacterButtonPressed: (payload) => dispatch(characters(payload)),
});

export const RemoteController = connect(
  mapStateToProps,
  mapDispatchToProps,
)(RemoteControllerComponent);
